import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from "material-ui/Grid";
import Input from "material-ui/Input";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControlLabel } from "material-ui/Form";
import { changeFuelCost, changeFuelCurrency } from "../../modules/fuel";
import "./FuelCostInput.css";

class FuelCostInput extends Component {
  handleCostInput = e => {
    const value = e.target.value;
    const input = e.target.name;

    if (input === "currency") this.props.changeFuelCurrency(value);
    else if (input === "cost") this.props.changeFuelCost(value);
  };

  render() {
    return (
      <div className="fuel-cost-input">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Input
            type="number"
            name="cost"
            value={this.props.cost}
            onChange={this.handleCostInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <RadioGroup
            style={{ display: "inline-block" }}
            aria-label="currency"
            name="currency"
            value={this.props.currency}
            onChange={this.handleCostInput}
          >
            <FormControlLabel value="USD" control={<Radio />} label="USD" />
            <FormControlLabel value="MXP" control={<Radio />} label="MXP" />
          </RadioGroup>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currency: state.fuel.currency,
    cost: state.fuel.cost
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeFuelCost,
      changeFuelCurrency
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FuelCostInput);



// WEBPACK FOOTER //
// ./src/components/FuelCostInput/FuelCostInput.js